import Vue from 'vue'
import VueRouter from 'vue-router'

//解决vue路由重复导航错误
//获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const Home = () => import('@/components/home/Home.vue')
// //
const Login = () => import('@/components/login/Login.vue')
const approval_no = () => import('@/components/login/approval_no.vue')
const approval_ing = () => import('@/components/login/approval_ing.vue')
const Regist = () => import('@/components/register/reg.vue')
const forget_password = () => import('@/components/forget_password/forget_password.vue')
const page404 = () => import('@/view/404.vue')
// //
const enterprise_information = () => import('@/view/basic_information/enterprise_information/index.vue')
const check_standard = () => import('@/view/basic_information/enterprise_information/check_standard.vue')
const set_enterprise = () => import('@/view/basic_information/enterprise_information/set_enterprise.vue')
const set_standard = () => import('@/view/basic_information/enterprise_information/set_standard.vue')
const set_range = () => import('@/view/basic_information/enterprise_information/set_range.vue')
//
const employees = () => import('@/view/basic_information/employees/index.vue')
const add_employees = () => import('@/view/basic_information/employees/add_employees.vue')
const employees_details = () => import('@/view/basic_information/employees/employees_details.vue')
/**
 * 重点人员模快
 * @returns 
 */
const pointperson = () => import('@/view/basic_information/pointperson/index.vue')
const add_pointperson = () => import('@/view/basic_information/pointperson/add_pointperson.vue')
const pointperson_details = () => import('@/view/basic_information/pointperson/pointperson_details.vue')
// //
const per_log = () => import('@/view/day_work/per_log.vue')
//
const bus_log = () => import('@/view/day_work/bus_log/index.vue')
const add_bus_log = () => import('@/view/day_work/bus_log/add_bus_log.vue')
const bus_log_details = () => import('@/view/day_work/bus_log/bus_log_details.vue')
//
const suspicious = () => import('@/view/day_work/suspicious/index.vue')
const add_suspicious = () => import('@/view/day_work/suspicious/add_suspicious.vue')
const suspicious_details = () => import('@/view/day_work/suspicious/suspicious_details.vue')
//
const refined = () => import('@/view/day_work/refined/index.vue')
const refined_details = () => import('@/view/day_work/refined/refined_details.vue')

// const pawn = () => src\view\day_work\refined\index.vue
//   import( '@/view/day_work/pawn/index.vue')
// const add_pawn = () =>
//   import( '@/view/day_work/pawn/add_pawn.vue')
// const pawn_details = () =>
//   import(
//      '@/view/day_work/pawn/pawn_details.vue'
//   )

const daily_inspect = () => import('@/view/day_work/daily_inspect/index.vue')
const add_daily_inspect = () => import('@/view/day_work/daily_inspect/add_daily_inspect.vue')
const daily_inspect_details = () => import('@/view/day_work/daily_inspect/daily_inspect_detalis.vue')
// //
const account_management = () => import('@/view/account_management/index.vue')
const add_account_management = () => import('@/view/account_management/add_account_management.vue')
const account_management_details = () => import('@/view/account_management/account_management_details.vue')
const role = () => import('@/view/account_management/role.vue'
)
// 通知公告
const notice = () =>
  import(/* webpackChunkName: "basic_information" */ '@/view/basic_information/notice/index.vue')

const notice_detail = () =>
  import(/* webpackChunkName: "basic_information" */ '@/view/basic_information/notice/notice_detail.vue')

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/enterprise_information' },
  { path: '/login', component: Login },
  { path: '/approval_ing', component: approval_ing },
  { path: '/approval_no', component: approval_no },
  { path: '/regist', component: Regist },
  { path: '/forget_password', component: forget_password },
  { path: '/404', component: page404 },
  {
    path: '/home',
    component: Home,
    redirect: '/enterprise_information',
    children: [
      {
        path: '/enterprise_information',
        component: enterprise_information
      },
      {
        path: '/enterprise_information/check_standard',
        component: check_standard,
      },
      {
        path: '/enterprise_information/set_enterprise',
        component: set_enterprise
      },
      {
        path: '/enterprise_information/set_standard',
        component: set_standard
      },
      {
        path: '/per_log/set_range',
        component: set_range
      },
      {
        path: '/employees',
        component: employees
      },
      {
        path: '/employees/add_employees',
        component: add_employees
      },
      {
        path: '/employees/employees_details',
        component: employees_details
      },
      {
        path: '/pointperson',
        component: pointperson
      },
      {
        path: '/pointperson/add_pointperson',
        component: add_pointperson
      },
      {
        path: '/pointperson/pointperson_details',
        component: pointperson_details
      },
      {
        path: '/per_log',
        component: per_log
      },
      {
        path: '/bus_log',
        component: bus_log
      },
      {
        path: '/bus_log/add_bus_log',
        component: add_bus_log
      },
      {
        path: '/bus_log/bus_log_details',
        component: bus_log_details
      },
      {
        path: '/suspicious',
        component: suspicious
      },
      {
        path: '/suspicious/add_suspicious',
        component: add_suspicious
      },
      {
        path: '/suspicious/suspicious_details',
        component: suspicious_details
      },
      {
        path: '/refined',
        component: refined
      },
      {
        path: '/refined/refined_details',
        component: refined_details
      },
      // {
      //   path: '/pawn_details',
      //   component: pawn_details
      // },
      {
        path: '/daily_inspect',
        component: daily_inspect
      },
      {
        path: '/daily_inspect/add_daily_inspect',
        component: add_daily_inspect
      },
      {
        path: '/daily_inspect/daily_inspect_details',
        component: daily_inspect_details
      },
      {
        path: '/account_management',
        component: account_management
      },
      {
        path: '/account_management/add_account_management',
        component: add_account_management
      },
      {
        path: '/account_management/account_management_details',
        component: account_management_details
      },
      {
        path: '/role',
        component: role
      },
      // 通知公告
      {
        path: '/notice',
        component: notice
      },
      {
        path: '/notice/notice_details',
        component: notice_detail
      },
    ]
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach(async (to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  next()
})

export default router
